import { Box, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import type { FilterRenderProps } from "../../grid/CompGrid";

const SEVERITIES = ["TRACE", "DEBUG", "INFO", "WARN", "ERROR", "FATAL"] as const;

export interface GridSeverityFilterPopoverProps extends FilterRenderProps {
  label?: string;
}

export function GridSeverityFilterPopover({
  value,
  onChange,
  label = "Severity",
}: GridSeverityFilterPopoverProps) {
  const selected = (Array.isArray(value) ? value : []) as string[];

  const handleToggle = (sev: string) => {
    const next = selected.includes(sev)
      ? selected.filter((s) => s !== sev)
      : [...selected, sev];
    onChange(next);
  };

  return (
    <Box sx={{ minWidth: 180 }}>
      <FormGroup>
        {SEVERITIES.map((sev) => (
          <FormControlLabel
            key={sev}
            control={
              <Checkbox
                size="small"
                checked={selected.includes(sev)}
                onChange={() => handleToggle(sev)}
              />
            }
            label={sev}
          />
        ))}
      </FormGroup>
    </Box>
  );
}
